import * as v from "valibot";

/**
 * ProxyClusterResource 响应信封 schema 工厂。
 *
 * 复用 envoy-gateway 的 `{ RequestId?, Data?, Error? }` 结构，
 * 但 Data 不再是 `v.any()`，而由调用方传入的 dataSchema 类型化。
 *
 * - list 查询：dataSchema = `v.object({ items: v.array(itemSchema) })`
 * - get  查询：dataSchema = itemSchema（单个资源对象本身）
 *
 * 泛型约束用 valibot 的 GenericSchema：这里是 valibot schema 的构建现场
 * （v.object/v.optional 等 valibot API），与特定库绑定；
 * 构建出的 schema 实现了 StandardSchemaV1，传给 dataSource.get() 时自动满足其约束。
 */
export function makeProxyResponseSchema<D extends v.GenericSchema>(dataSchema: D) {
  return v.object({
    RequestId: v.optional(v.string()),
    Data: v.optional(dataSchema),
    Error: v.optional(
      v.object({
        Code: v.optional(v.string()),
        Message: v.optional(v.string()),
      }),
    ),
  });
}
